module.exports = __webpack_public_path__ + "static/img/banner3.000a89a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/banner3.jpg
// module id = 9CmU
// module chunks = 0